import AnimatedImage from 'core-lib/components/AnimatedImage';
import { useLocationHandler } from 'core-lib/hooks/useLocationHandler';
import { NativePermission } from 'core-lib/types/NativePermission';
import { openGpsSettings, openLocationSettings } from 'core-lib/utils/locationV2';
import BackButton from 'ui-v2/components/BackButton';
import { Button } from 'ui-v2/components/Button';
import Modal from 'ui-v2/components/Modal';
import { Typography } from 'ui-v2/components/Typography';
import s from './LocationHandler.module.scss';
import { UserLocationRequirementType } from 'core-lib/types/Location';

export const LocationHandler = () => {
  const { askLocation, setAskLocation, locationRequest, locationMaster, onManualCloseBtmSheet } =
    useLocationHandler();

  return (
    <div className={s.locationModals}>
      <Modal
        show={askLocation !== 'NONE'}
        head={{
          show: false,
          title: '',
          onClose: onManualCloseBtmSheet,
        }}
        customeBodyStyle={{ padding: '0px' }}
        rootStyle={{ zIndex: '9999' }}
        closeOnClickOutside={false}
      >
        <div className={s.confirm_screen}>
          <div className={s.hide}>
            <BackButton onBack={onManualCloseBtmSheet} />
          </div>

          <div className={s.wrapper}>
            <div className={s.img}>
              <AnimatedImage src="https://parkplus-bkt-img.parkplus.io/production/common/public/locationp_20250417154622573513_60f53a27-41d4-4b4b-8147-39a20d6ae79f.webp" />
            </div>

            <div className={s.content_text}>
              <Typography
                label={locationRequest?.bottomSheetData?.title || 'Allow location access'}
                variant={'h_4_bold'}
              />
            </div>

            <div className={s.content_subtext}>
              <Typography
                label={
                  locationRequest?.bottomSheetData?.subtitle ||
                  'Turn on exact location access for a better experience while using the app'
                }
                variant={'body_3_regular'}
                color="secondary"
              />
              <Typography
                label={locationRequest?.bottomSheetData?.description}
                variant={'body_3_regular'}
                color="brand"
                style={{ paddingTop: '4px' }}
              />
            </div>
          </div>

          <div className={s.cta}>
            <Button
              label="Share my location"
              fullWidth
              onClick={async () => {
                setAskLocation('NONE');

                if (askLocation === 'GPS') {
                  const result = await openGpsSettings();
                  if (result) locationMaster();
                  else setAskLocation('GPS');
                } else if (askLocation === 'LOCATION') {
                  const permission = await openLocationSettings();
                  if ([NativePermission.Accepted, NativePermission.Denied].includes(permission)) {
                    locationMaster();
                  } else setAskLocation('LOCATION');
                } else {
                  setTimeout(() => {
                    locationMaster(true);
                  }, 100);
                }
              }}
            />

            {locationRequest?.payload?.locationRequirementType !==
              UserLocationRequirementType.Mandatory && (
              <div className={s.dismissCta}>
                <Button
                  label="Dismiss"
                  onClick={onManualCloseBtmSheet}
                  fullWidth
                  variant="ghost_color"
                />
              </div>
            )}
          </div>
        </div>
      </Modal>
    </div>
  );
};
